export default __webpack_public_path__ + "static/media/BosaImportants2.ea03b057.JPG";